import { render } from "./batteryStatus.vue?vue&type=template&id=e32b52f2"
import script from "./batteryStatus.vue?vue&type=script&lang=js"
export * from "./batteryStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__